import { MatDialogConfig } from '@angular/material/dialog';

export const SERASA_CASE_CODE = 'caso-megavazamento-de-dados';
export const TUTORIAL_VIDEO_URL = 'assets/video/Serasa-Tutorial.mp4';

/** Seconds at which each client step starts in the tutorial video. */
export const TUTORIAL_STEP_TIMESTAMPS = {
  HOME: 0,
  ELIGIBILITY_QUESTIONNAIRE: 56,
  IDENTIFICATION_QUESTIONNAIRE: 85,
  KYC: 120,
  SIGNATURE: 171,
  CONSENTS: 204,
} as const;

export const TUTORIAL_DIALOG_CONFIG: MatDialogConfig = {
  width: '90vw',
  maxWidth: '800px',
  panelClass: 'tutorial-video-dialog-panel',
  disableClose: false,
  data: { videoUrl: TUTORIAL_VIDEO_URL },
};
